import { useList } from "../.."

export const useListActivityLogs = ({ params = {} }) => {

    const { data, isLoading, refetch } = useList(
        'activity/logs',
        { ...params },
    );

    return {
        activityLogs: data?.data?.data,
        logsLoading: isLoading,
        logRefetch: refetch
    }
}